// @import dependencies
import React, { CSSProperties, ReactElement, useState } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { MdDone, MdViewList } from 'react-icons/md'
import { BounceLoader } from 'react-spinners'
import { Modal } from 'react-bootstrap'
import IconComponent from 'app_components/commons/icons'
// @end dependencies

// @import components
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import { useColors } from 'app_hooks/useColors'
// @end components

// @import styles
import './SavingIndicator.scss'
import ButtonComponent from '../Button/ButtonComponent';
// @end styles

export type TypesStateSavingIndicator = 'saved' | 'saving' | 'failed'

interface ISavingIndicatorDetails {
  row: number,
  status: 'ERROR' | 'OK',
  message?: string
}

interface ISavingIndicatorProps {
  state: TypesStateSavingIndicator;
  className?: string
  style?: CSSProperties
  id?: string
  withText?: boolean;
  savedText?: string;
  savingText?: string;
  failedText?: string;
  descriptionText?: string;
  savingIcon?: ReactElement
  details?: ISavingIndicatorDetails[]
}

const SavingIndicator: React.FC<ISavingIndicatorProps> = (props) => {

  const [openDetails, updateOpenDetails] = useState<boolean>(false)

  const getIndicator = () => {
    switch(props.state) {
      case 'saved':
        return (
          <MdDone
            className='done-icon-indicator'
            color='var(--primary)'
          />
        )
      case 'saving':
        return props.savingIcon ? props.savingIcon : (
          <BounceLoader
            color='var(--secondary)'
            size={19}
          />
        )
      case 'failed':
        return (
          <AiOutlineCloseCircle
            className='failed-icon-indicator'
          />
        )
      default:
          return null;
    }
  }

  const getText = () => {
    switch(props.state) {
      case 'saved':
        return props.savedText || 'Guardado'
      case 'saving':
        return props.savingText || 'Guardando...'
      case 'failed':
        return props.failedText || 'Error al guardar'
      default:
        return '';
    }
  }

  const showDetails = () => {
    if (!props.details) return null
    if (props.details.length === 0) return null

    if (['saved', 'failed'].includes(props.state)) {
      return (
        <ButtonComponent
          variant='clean'
          style={{ marginBottom: '10px', fontSize: '.6rem' }}
          className=''
          onClick={() => updateOpenDetails(!openDetails)}
        >
          <ButtonComponent.Icon>
            <MdViewList size={'1rem'} />
          </ButtonComponent.Icon>
          Ver detalles
        </ButtonComponent>
      )
    }
  }

  return(
    <div
      className={`saving_indicator-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <div className="saving_indicator--icon">
        {getIndicator()}
        {props.withText ?
          <LabelComponent
            style={{
                fontWeight: 700
            }}
          >
            {getText()}
          </LabelComponent>
        : null}
      </div>
      {props.descriptionText && props.state !== 'saving' ?
        <LabelComponent
          style={{
            color: 'var(--text2)',
            fontSize: '0.8rem'
          }}
        >
          {props.descriptionText}
        </LabelComponent>
      : null}
      {showDetails()}
      <ModalDetails
        open={openDetails}
        onClose={() => updateOpenDetails(!openDetails)}
        data={props.details}
        header={{
          title: 'Detalles de la carga',
          closeButton: true
        }}
      />
    </div>
  );
}
type IModalHeader = {
  title: string,
  closeButton?: boolean
}
interface IModalDetailsProps {
  open: boolean
  data?: ISavingIndicatorDetails[]
  header?: IModalHeader
  className?: string
  style?: CSSProperties
  hideCloseButton?: boolean
  onClose?: ()=>any
}

const ModalDetails: React.FC<IModalDetailsProps> = (props) => {

  const [colors] = useColors()
  const { open, onClose, header, data } = props

  const handleClickClose = () => {
    if(onClose){
      onClose()
    }
  }

  return (
    <Modal
      show={open}
      onHide={() => handleClickClose()}
      className={`modal_save_indicator_details-component ${props.className ? props.className : ''}`}
      size='lg'
    >
      {header && (
        <Modal.Header>
          {header?.title && (
            <Modal.Title>
              {header?.title}
            </Modal.Title>
          )}
          {header?.closeButton && (
            <div className="close-button" onClick={() => handleClickClose()}>
              <IconComponent
                color={colors.secondary}
                width='1.5rem'
                height='1.5rem'
                fontawesome={{
                  icon: 'fas fa-times-circle',
                }}
              />
            </div>
          )}
        </Modal.Header>
      )}
      <Modal.Body>
        <table className='table'>
          <thead>
            <tr>
              <th>Row</th>
              <th>Estado</th>
              <th>Mensaje</th>
            </tr>
          </thead>
          <tbody>
            {data && data.map((item) => (
              <tr>
                <td>{item.row}</td>
                <td>{item.status}</td>
                <td>{item.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  )
}

export default SavingIndicator;
